// import React from "react";
// import Button from "react-bootstrap/Button";
// import "./Application.css";
// import NavigationBar from "../../Components/NavigationBar";

// function ApplicationTemplates() {
//   const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL;
//   const handleDownload = (filePath) => {
//     window.open(
//       `${FILE_BASE_URL}/api/Uploads/ApplicationTemplates/${filePath}`,
//       "_blank"
//     );
//   };

//   return (
//     <div>
//       <NavigationBar />
//       <div className="page-header">
//         <h1 className="downloadpage-tittle">Application Templates</h1>
//         <p className="page-subtitle">
//           Explore and apply for prestigious research awards opportunities offered by the University Research Council.
//         </p>
//       </div>
//       <div className="award-details-container">
//         {/* Research Excellence Awards (Tier 4*) */}
//         <div className="award-container">
//           <h1 className="award-title">Research Excellence Awards (Tier 4*)</h1>
//           <p className="award-description">
//             The University Research Council (URC) at the University of Peradeniya recognizes outstanding permanent academic and administrative staff members who meet the eligibility criteria for the Tier 4* category, based on their h-index (Hirsch Index) as outlined in the transparent research performance scheme of UGC Circular 05/2018. The URC invites applications for this prestigious award twice annually, prior to the iPURSE event. Eligible candidates are required to submit their applications using the designated template provided by the URC.
//           </p>
//           <h3 className="criteria">Minimum h-index values to qualify for Tier 4*:</h3>
//           <ul className="criteria-list">
//             <li><span className="criteria-highlight">Medical and Dental Sciences:</span> Minimum h-index of 20</li>
//             <li><span className="criteria-highlight">Pure Sciences (except Mathematics):</span> Minimum h-index of 17</li>
//             <li><span className="criteria-highlight">Agriculture, Allied Health Sciences, Engineering, IT and Computing, and Veterinary Sciences:</span> Minimum h-index of 14</li>
//             <li><span className="criteria-highlight">Arts, Fine Arts, Humanities & Social Sciences, Law, Management, and Mathematics:</span> Minimum h-index of 11</li>
//           </ul>
//           <div className="download-section">
//             <label className="download-label">Download Template:</label>
//             <button
//               className="download-btn"
//               onClick={() => handleDownload("Research_Excellence_Award_(Tier4).pdf")}
//             >
//               Download
//             </button>

//           </div>
//         </div>

//         {/* URC Research Awards */}
//         <div className="award-container">
//           <h1 className="award-title">URC Research Awards</h1>
//           <h3 className="criteria">Eligibility and Selection Criteria</h3>
//           <p className="award-description">
//             To acknowledge and incentivize outstanding research and creative achievements within the past year, the University Research Council (URC) of the University of Peradeniya (UoP) establishes the URC Research Awards. These awards celebrate the contributions of researchers who have significantly advanced their fields and motivate further research endeavors across the university.
//           </p>
//           <div className="award-types">
//             <h4 className="sub-criteria">Types of Awards</h4>
//             <ul className="criteria-list">
//               <li>URC Research Award for the Outstanding Researcher (Tier 1)</li>
//               <li>URC Research Award for the Outstanding Researcher (Tier 2)</li>
//             </ul>
//             <p className="note">A certificate and a plaque will be awarded.</p>
//           </div>
//           <div className="eligibility-criteria">
//             <h4 className="sub-criteria">Eligibility for Awards</h4>
//             <h5 className="criteria-type">General Criteria:</h5>
//             <ul className="criteria-list">
//               <li>A permanent member of the UoP.</li>
//               <li>Publications, patents, and other achievements considered for the award must be from January to December of the award year.</li>
//               <li>Should have at least one Q1 and Q2 Journal.</li>
//               <li>Manuscripts that are accepted but not published will not be considered, but articles that are published with a DOI number but have not been allocated to an issue will be considered.</li>
//               <li>In all publications and works submitted for evaluation, the applicant's primary affiliation must be clearly stated as 'University of Peradeniya'.</li>
//               <li>The publications presented in the symposia for undergraduate programs at UoP are not eligible for consideration.</li>
//             </ul>
//             <h5 className="criteria-type">Specific Criteria:</h5>
//             <table className="eligibility-table">
//               <thead>
//                 <tr>
//                   <th>Faculties/Disciplines</th>
//                   <th>Tier 1 (Associate Professors/Professors and Senior Professors)</th>
//                   <th>Tier 2 (Lecturers and Senior Lecturers)</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td>Medicine, Engineering, Agriculture, and Science (except Mathematics)</td>
//                   <td>25</td>
//                   <td>20</td>
//                 </tr>
//                 <tr>
//                   <td>Dental, Allied Health Sciences, Veterinary Sciences, Arts and Management, Mathematics</td>
//                   <td>20</td>
//                   <td>15</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//           <div className="application-procedure">
//             <h4 className="sub-criteria">Application Procedure</h4>
//             <ul className="criteria-list">
//               <li>URC will call for applications in March every year, and awards will be awarded at the PURSE/iPURSE.</li>
//               <li>The eligible academic staff members should submit a duly completed application form with the evidence for publication/s and other eligible criteria before the deadline.</li>
//             </ul>
//           </div>
//           <div className="selection-method">
//             <h4 className="sub-criteria">Method of Selection</h4>
//             <ol className="criteria-list">
//               <li>URC will appoint an Award committee to evaluate the applications and to select the winners, which will be presented to the MC of the URC for approval.</li>
//               <li>The applications submitted without the required information will be rejected.</li>
//             </ol>
//           </div>
//           <div className="download-section">
//             <label className="download-label">Download Template:</label>
//             <button
//               className="download-btn"
//               onClick={() => handleDownload("URC_Research_Awards.pdf")}
//             >
//               Download
//             </button>
//           </div>
//         </div>

//         {/* Recognition Awards */}
//         <div className="award-container">
//           <h1 className="award-title">Recognition Awards</h1>
//           <p className="award-description">
//             The University Research Council (URC) establishes these grants to honor recipients of research grants awarded in the year prior to the recognition year, celebrating their contributions to advancing academic excellence at the University of Peradeniya. The following matrices are used to decide these recognition grants.
//           </p>
//           <div className="metrics-section">
//             <h4 className="sub-criteria">Evaluation Metrics</h4>
//             <ol className="criteria-list">
//               <li><strong>Grant Award Amount:</strong>
//                 <ul>
//                   <li><strong>Total Amount:</strong> This metric provides a direct indication of the scale and perceived value of the research by funding agencies.</li>
//                   <li><strong>Distribution:</strong> Evaluate the balance between national and international grants, indicating the researcher’s reach and competitiveness.</li>
//                 </ul>
//               </li>
//               <li><strong>Grant Source Prestige:</strong>
//                 <ul>
//                   <li><strong>Tiering of National Grants:</strong> Classify national grants based on their prestige or difficulty in securing, weighting them accordingly.</li>
//                   <li><strong>Reputational Ranking of International Agencies:</strong> Use established rankings like SCImago Institutions Rankings or Leiden Ranking to assign points based on the grant agency’s international standing.</li>
//                 </ul>
//               </li>
//               <li><strong>Grant Type:</strong>
//                 <ul>
//                   <li><strong>Principal Investigator (PI) vs. Co-Investigator:</strong> Assign a higher weight to grants where the researcher is the PI, demonstrating leadership and responsibility.</li>
//                   <li><strong>Individual vs. Collaborative Grants:</strong> Consider the balance between individual and collaborative grants, providing insight into the researcher’s independence and ability to work with others.</li>
//                 </ul>
//               </li>
//             </ol>
//           </div>
//           <div className="eligibility-section">
//             <h4 className="sub-criteria">Eligibility Criteria</h4>
//             <ul className="criteria-list">
//               <li>The granted research project must list the University of Peradeniya as the institutional affiliation for the researcher(s).</li>
//               <li>Research grants must be currently active and have been running for at least three months as of January 1st of the application year.</li>
//               <li>The funded research project's completion date must fall after June 30th of the year the grant will be awarded.</li>
//             </ul>
//             <p className="note"><strong>The following grants are not eligible:</strong></p>
//             <ul className="criteria-list">
//               <li>Capacity building grants</li>
//               <li>Grants outside the specified time windows</li>
//             </ul>
//           </div>
//           <div className="normalization-section">
//             <h4 className="sub-criteria">Normalization</h4>
//             <p className="award-description">The eligible total mark is based on the researcher's career stage and the field of study to ensure fair comparison. The following table specifies the total marks required:</p>
//             <table className="eligibility-table">
//               <thead>
//                 <tr>
//                   <th>Faculties/Disciplines</th>
//                   <th>From 0 to 15 Years Post-PhD</th>
//                   <th>Over 15 Years Post-PhD</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td>Medicine, Science (except Mathematics), Engineering, and Agriculture</td>
//                   <td>5</td>
//                   <td>10</td>
//                 </tr>
//                 <tr>
//                   <td>Dental, Allied Health Sciences, Veterinary Sciences, Arts and Management</td>
//                   <td>4</td>
//                   <td>8</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//           <div className="download-section">
//             <label className="download-label">Download Template:</label>
//             <button
//               className="download-btn"
//               onClick={() => handleDownload("Recognition_Awards.pdf")}
//             >
//               Download
//             </button>
//           </div>
//         </div>

//         {/* Prof. Lakshman Samaranayake Awards */}
//         <div className="award-container">
//           <h1 className="award-title">Prof. Lakshman Samaranayake Awards</h1>
//           <div className="evaluation-criteria">
//             <h4 className="sub-criteria">Evaluation Criteria</h4>
//             <p className="award-description">According to the regulations governing the award, candidates shall supply evidence of research at the highest international level in the form of:</p>
//             <ol className="criteria-list">
//               <li>Documented evidence of international recognition of research accomplishments such as publications in high-impact factor venues, h-Index, etc.</li>
//               <li>Quality and quantity of research publications.</li>
//               <li>Quality and quantity of research grants, considering the prestige of the funding bodies and the magnitude of the awards.</li>
//               <li>High-impact applied research work including acclaimed creative arts, productions, innovations, and approved patents, if any.</li>
//             </ol>
//           </div>
//            <div className="eligibility-section">
//             <h4 className="sub-criteria">Eligibility Criteria</h4>
//             <ul className="criteria-list">
//               <li>To be eligible for the award, the minimum total mark required is 70.</li>
//               <li>Research grants must be currently active and have been running for at least three months as of January 1st of the application year.</li>
//               <li>In case of a tie, the selection committee appointed by the Dean may either decide to split the Award or select a candidate based on the quality of papers and research grants. </li>
//             </ul>

//           </div>
//           <div className="download-section">
//             <label className="download-label">Download Template:</label>
//             <button
//               className="download-btn"
//               onClick={() => handleDownload("Prof._Lakshman_Samaranayake_Awards.pdf")}
//             >
//               Download
//             </button>
//           </div>
//         </div>

//         {/* Research Publication Facilitation Fund (APC) */}
//         <div className="award-container">
//           <h1 className="award-title">Research Publication Facilitation Fund (APC)</h1>
//           <p className="award-description">
//             The University Research Council [URC] is pleased to announce a scheme providing financial assistance up to a maximum of USD 1500.00 per year for researchers at the University of Peradeniya to facilitate publishing in high-ranking peer-reviewed journals. Additionally, an APC of Rs 10,000 per paper (up to 2 papers) is provided for papers published in the Ceylon Journal of Science. The 2nd paper must be published in collaboration with members from a different university.
//           </p>
//           <p className="award-description">
//             Publishing in reputed journals enhances the visibility of research work, bringing reputation and publicity to both researchers and the university. High-impact international peer-reviewed journals often charge page fees of USD 2500 or more, particularly for open-access articles, which significantly increase citation rates.
//           </p>
//           <p className="award-description">
//             Supporting researchers with publication costs is a priority for the URC. The Research Publication Facilitation Fund [RPFF] addresses this need, encouraging scholarly publications in high-impact journals.
//           </p>
//           <div className="application-instructions">
//             <h4 className="sub-criteria">Preliminary Application Instructions</h4>
//             <p className="note"><strong>Step 1:</strong></p>
//             <ul className="criteria-list">
//               <li>This is a fillable form, which you can fill using Adobe Acrobat Reader (latest versions).</li>
//               <li>Furnish all details, sign the application, and obtain signatures from the Head and Dean.</li>
//               <li>Attach a copy of the complete manuscript and the acceptance letter.</li>
//               <li>Only full-length articles published in SCI/SSCI/SCI-expanded/SSCI-expanded with an impact factor of 2 or higher will be considered for Article Processing Charge (APC).</li>
//             </ul>
//             <p className="note"><strong>Step 2:</strong></p>
//             <ul className="criteria-list">
//               <li>Upon receiving APC approval from URC (usually via email), submit the invoice for APC payment and the credit card statement. Payment must be made by a permanent staff member of the University of Peradeniya.</li>
//               <li>If two authors claim for the same article, submit two separate applications together (one copy of the manuscript and invoice is sufficient). If one author paid the APC, a consent letter from the second author is required.</li>
//               <li>Funding is subject to availability.</li>
//             </ul>
//           </div>
//           <div className="download-section">
//             <label className="download-label">Download Template:</label>
//             <button
//               className="download-btn"
//               onClick={() => handleDownload("Research_Publication_Facilitation_Fund_(APC).pdf")}
//             >
//               Download
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ApplicationTemplates;

import React from "react";
import Button from "react-bootstrap/Button";
import "./Application.css";
import NavigationBar from "../../Components/NavigationBar";
import { Award, Star, Info } from "lucide-react";

function ApplicationTemplates() {
  const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL;
  const handleDownload = (filePath) => {
    window.open(
      `${FILE_BASE_URL}/api/Uploads/ApplicationTemplates/${filePath}`,
      "_blank"
    );
  };
  const handleDownloadCriteria = (filePath1, type) => {
    window.open(
      `${FILE_BASE_URL}/api/Uploads/ApplicationCriteria/${filePath1}`,
      "_blank"
    );
  };

  return (
    <div>
      <NavigationBar />
      <div className="page-header">
        <h1 className="downloadpage-tittle">Application Templates</h1>
        <p className="page-subtitle">
          Explore and apply for prestigious research awards opportunities
          offered by the University Research Council.
        </p>
      </div>
      <div className="award-details-container">
        {/* Excellence Awards Section */}
        <section className="excellence-awards">
          <div className="awards-list1">
            <div className="award-item">
              <h3 className="award-title">
                Research Excellence Awards (Tier 4*)
              </h3>
              <div className="award-box">
                <Star className="award-icon1" />
                <p>
                  Recognizes permanent academic and administrative staff with
                  high h-index values across disciplines, based on UGC Circular
                  05/2018 criteria.
                </p>
                <div className="award-actions">
                  <span
                    className="more-details1"
                    onClick={() =>
                      handleDownloadCriteria(
                        "Research_Excellence_Award_(Tier4)_criteria.pdf"
                      )
                    }
                    style={{
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    <Info
                      className="info-icon1"
                      style={{ marginRight: "5px"}}
                    />
                    More Details
                  </span>

                  <div className="download-group">
                    <label>Application Template: </label>
                    <button
                      className="download-btn1"
                      onClick={() =>
                        handleDownload("Research_Excellence_Award_(Tier4).pdf")
                      }
                    >
                      Download
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="award-item">
              <h3 className="award-title">URC Research Awards</h3>
              <div className="award-box">
                <Award className="award-icon1" />
                <p>
                  Honors outstanding researchers (by rank) for recent
                  publications, patents, and grants, with awards presented at
                  PURSE/iPURSE events.
                </p>
                <div className="award-actions">
                  <span
                    className="more-details1"
                    onClick={() =>
                      handleDownloadCriteria("URC_Research_Awards_criteria.pdf")
                    }
                    style={{
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    <Info
                      className="info-icon1"
                      style={{ marginRight: "5px" }}
                    />
                    More Details
                  </span>
                  <div className="download-group">
                    <label>Application Template: </label>
                    <button
                      className="download-btn1"
                      onClick={() => handleDownload("URC_Research_Awards.pdf")}
                    >
                      Download
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="award-item">
              <h3 className="award-title">Recognition Awards</h3>
              <div className="award-box">
                <Award className="award-icon1" />
                <p>
                  Celebrates researchers who secured significant national or
                  international grants, weighted by funding amount, prestige,
                  and role (PI/Co-I).
                </p>
                <div className="award-actions">
                  <span
                    className="more-details1"
                    onClick={() =>
                      handleDownloadCriteria("Recognition_Awards_criteria.pdf")
                    }
                    style={{
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    <Info
                      className="info-icon1"
                      style={{ marginRight: "5px" }}
                    />
                    More Details
                  </span>
                  <div className="download-group">
                    <label>Application Template: </label>
                    <button
                      className="download-btn1"
                      onClick={() => handleDownload("Recognition_Awards.pdf")}
                    >
                      Download
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="award-item">
              <h3 className="award-title">
                Prof. Lakshman Samaranayake Awards
              </h3>
              <div className="award-box">
                <Award className="award-icon1" />
                <p>
                  Awards top-tier researchers with international recognition,
                  evaluated by publications, grants, h-index, citations, and
                  impactful work (minimum 70 marks required).
                </p>
                <div className="award-actions">
                  <span
                    className="more-details1"
                    onClick={() =>
                      handleDownloadCriteria(
                        "Prof._Lakshman_Samaranayke_Awards_criteria.pdf"
                      )
                    }
                    style={{
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    <Info
                      className="info-icon1"
                      style={{ marginRight: "5px" }}
                    />
                    More Details
                  </span>
                  <div className="download-group">
                    <label>Application Template: </label>
                    <button
                      className="download-btn1"
                      onClick={() =>
                        handleDownload("Prof._Lakshman_Samaranayake_Awards.pdf")
                      }
                    >
                      Download
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="award-item">
              <h3 className="award-title">
                Research Publication Facilitation Fund (APC)
              </h3>
              <div className="award-box">
                <Award className="award-icon1" />
                <p>
                  Provides financial support (up to USD 1500/year) to permanent
                  staff for publishing in high-impact journals or the Ceylon
                  Journal of Science.
                </p>
                <div className="award-actions">
                  <span
                    className="more-details1"
                    onClick={() =>
                      handleDownloadCriteria(
                        "Research_Publication_Facilitation_Fund_(APC)_criteria.pdf"
                      )
                    }
                    style={{
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    <Info
                      className="info-icon1"
                      style={{ marginRight: "5px" }}
                    />
                    More Details
                  </span>
                  <div className="download-group">
                    <label>Application Template: </label>
                    <button
                      className="download-btn1"
                      onClick={() =>
                        handleDownload(
                          "Research_Publication_Facilitation_Fund_(APC).pdf"
                        )
                      }
                    >
                      Download
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default ApplicationTemplates;